module.exports = __webpack_public_path__ + "assets/img/ds8.04f88ebf.jpg";